<template>
  <div style="width: 100%; margin-top: 16px">
    <div v-for="(item, index) in optionsList" :key="index" class="option-item" :class="{
      isActive: isActive(item),
      isTrue: isTrue(item),
      isFalse: isFalse(item),
    }" @click.stop="select(item.title)">
      <div class="questionSeq" v-if="styleType == 1">
        <img style="margin-right: 10px; width: 20px; height: 20px;" v-if="isTrue(item)"
          src="../../../assets/images/new-right.png" alt="" />
        <img style="margin-right: 10px; width: 20px; height: 20px;" v-else-if="isFalse(item)"
          src="../../../assets/images/new-error.png" alt="" />
        <el-radio v-if="!readonly && !isTrue(item) && !isFalse(item)" :value="selectData" :label="item.title">{{ ""
        }}</el-radio>
      </div>
      <div v-if="showTitle" style="text-align: right;" class="questionSeq">
        <!-- {{ item.title }} -->
        {{ serialNumber[index] }}
      </div>
      <bc-view-common flex-box="1" :border="false" :content="item.content" :fileInfo="item.fileInfo"></bc-view-common>
    </div>
  </div>
</template>

<script>
export default {
  name: "bc-view-option-radio",
  props: {
    option: {
      type: [String, Array],
      default: "",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: "radio",
    },
    typeOk: {
      type: String,
      default: "false",
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
    isAnswerResults: {
      type: [String, Object],
      default: "",
    },
    styleType: {
      type: [String, Number],
      default: "1",
    }
  },
  data() {
    return {
      optionsList: [],
      selectData: "",
      serialNumber: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  computed: {},
  watch: {
    option: {
      handler(val) {
        try {
          if (Array.isArray(val)) {
            this.optionsList = val.map(function (item) {
              return typeof item == "object" ? item : JSON.parse(item);
            });
          } else {
            this.optionsList = JSON.parse(val);
          }
        } catch (err) {
          this.optionsList = [];
        }
      },
      immediate: true,
    },
    isAnswerResults: {
      handler(val) {
        if (typeof val == "object") {
          if (val.value == "正确") {
            this.selectData = "A";
          } else if (val.value == "错误") {
            this.selectData = "B";
          } else {
            this.selectData = val.value;
          }
        } else {
          if (val == "正确") {
            this.selectData = "A";
          } else if (val == "错误") {
            this.selectData = "B";
          } else {
            this.selectData = val;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    isActive(item) {
      return item.title === this.selectData && !this.readonly;
    },
    isTrue(item) {
      if (this.type === "radio") {
        return (
          this.answer.answerResults &&
          this.answer.answerResults.includes(item.title) &&
          this.answer.answerSituation === "1" &&
          this.readonly
        );
      } else {
        return (
          this.answer.answerResults &&
          this.answer.answerResults.includes(item.content) &&
          this.answer.answerSituation === "1" &&
          this.readonly
        );
      }
    },
    isFalse(item) {
      if (this.type === "radio") {
        return (
          this.answer.answerResults &&
          this.answer.answerResults.includes(item.title) &&
          this.answer.answerSituation === "0" &&
          this.readonly
        );
      } else {
        return (
          this.answer.answerResults &&
          this.answer.answerResults.includes(item.content) &&
          this.answer.answerSituation === "0" &&
          this.readonly
        );
      }
    },
    select(item) {
      if (this.typeOk == "false") {
        if (this.isAnswerx) return;
      }
      if (this.readonly) return;
      this.selectData = item;
      this.$emit("change", item);
    },
  },
};
</script>

<style scoped lang="scss">
.option-item+.option-item {
  margin-top: 16px;
}

.option-item {
  // background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  cursor: pointer;
  transition: all ease 0.3s;
  border: 1px solid #fbfbfb;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #fff;
  margin: 0 5px;

  .questionSeq {
    padding: 8px 0;
    width: auto;
  }

  &.isActive {
    //background: #ccc;
    border-color: #2e9adb;
  }

  &.isTrue {
    border: 1px solid #70b603;

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      border-color: #70b603;
      background: #70b603;
    }
  }

  &.isFalse {
    border: 1px solid #d9001b;

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      border-color: #d9001b;
      background: #d9001b;
    }
  }

  &:hover {
    // background: #ddd;
    border-color: #C5E3F8;
    transform: scale(1.003);
    transition: all 0.5s;
  }

  ::v-deep .content {
    cursor: pointer;
  }

  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
      cursor: pointer;
    }
  }
}
</style>
